module.exports = __webpack_public_path__ + "img/24n.83daa9d8.png";